import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { authApi, errDetail } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    authApi.google(sid)
      .then((u) => { setUser(u); window.history.replaceState(null, "", loc.pathname); nav(loc.pathname || "/studio", { replace: true }); })
      .catch((e) => { toast.error(errDetail(e)); setUser(false); nav("/login", { replace: true }); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
